/// این مدل کار مدیریت فعال شدن عملگرهای فاکتور را انجام میدهد
export class OrderActionControlModel {
    TemporaryRegisteringInvoice: boolean;
    SaveInvoice: boolean;
    PreparationPrintInvoice: boolean;
    CustomerPrintInvoice: boolean;
    KitchenPrintInvoice: boolean;
    ClearedWithoutPrintingInvoice: boolean;
    ClearingInvoice: boolean;
    MixClearing: boolean;
    clearnoprint: boolean;
    advanveclear: boolean;
    ChangePrintType: boolean;
}
export enum OrderActionEnum {
    TemporaryRegisteringInvoice = 1,
    SaveInvoice = 2,
    PreparationPrintInvoice = 3,
    CustomerPrintInvoice = 4,
    KitchenPrintInvoice = 5,
    ClearedWithoutPrintingInvoice = 6,
    ClearingInvoice = 7,
    MixClearing = 8,
    clearnoprint = 9,
    advanveclear = 10,
    ChangePrintType = 11,
}

